import {
    all, call, put, select, takeLatest, delay,
  } from 'redux-saga/effects';
  import { message } from 'antd';
  import {
    COMERCIA_WIFI_AUTHORIZE_API_FAILURE,
    COMERCIA_WIFI_AUTHORIZE_API_REQUEST,
    COMERCIA_WIFI_AUTHORIZE_API_SUCCESS,
    COMERCIA_WIFI_IS_AVALIABLE_API_FAILURE,
    COMERCIA_WIFI_IS_AVALIABLE_API_REQUEST,
    COMERCIA_WIFI_IS_AVALIABLE_API_SUCCESS,
    COMERCIA_WIFI_NEW_TRANSACTION_FAILURE,
    COMERCIA_WIFI_NEW_TRANSACTION_REQUEST,
    COMERCIA_WIFI_NEW_TRANSACTION_SUCCESS,
    COMERCIA_WIFI_REBATE_API_FAILURE,
    COMERCIA_WIFI_REBATE_API_REQUEST,
    COMERCIA_WIFI_REBATE_API_SUCCESS,
    COMERCIA_WIFI_LAST_TRANSACTION_API_FAILURE,
    COMERCIA_WIFI_LAST_TRANSACTION_API_REQUEST,
    COMERCIA_WIFI_LAST_TRANSACTION_API_SUCCESS,
    LAUNCH_COMERCIA_WIFI_AUTHORIZE,
    LAUNCH_COMERCIA_WIFI_IS_AVALIABLE,
    LAUNCH_COMERCIA_WIFI_REBATE,
    LAUNCH_COMERCIA_WIFI_LAST_TRANSACTION,
  } from '../actions/constants/comercia.datafono.wifi.constants';
  import { externalRequest, externalTimeoutRequest } from '../../helpers/request.helper';

  const TRANSACTION_RESPONSE_STATUS_OK = 0;
  const DATAFONO_PORT = `${window.GIO_CONFIG.CUSTOM_NODE_ENV === 'produccion' ? '2011' : '2002'}`; //2011 produccion

  const RESPONSE_ERROR = {
    "1010": "Error de inicialización",
    "1001": "Datáfono ocupado (operación en progreso)",
    "1": "MSGID incorrecto",
    "2": "Error de formato",
    "3": "Error de sintáxis",
    "4": "Error de parámetros",
    "5": "Tipo desconocido",
    "6": "Error de aplicación ISO",
    "7": "Error de aplicación EMV",
    "12": "Operación finalizada",
    "13": "Error de inicio Pinpad",
    "14": "Error de Pinpad",
    "15": "Tarjeta no válida",
    "16": "Operación cancelada",
    "17": "Excedido tiempo de expiración de operación",
    "18": "Operación rechazada",
    "19": "Tarjeta extraída",
    "21": "Fallo del dispositivo",
    "23": "Fallo de encriptación",
    "24": "Error genérico",
    "25": "Red no disponible",
    "26": "Operación anulada",
    "000": "Aprobada / Procesada",
    "100": "Procesamiento fuera de línea en el terminal",
    "101": "Rechazada: tarjeta caducada",
    "105": "Rechazada",
    "106": "Rechazada: se excedió el límite de PIN",
    "117": "Rechazada: PIN incorrecto",
    "126": "Rechazada: bloqueo de PIN no válido",
    "127": "Rechazada: datos de tarjeta cifrados no válidos",
    "129": "Rechazada: CVV2/CVC2 incorrecto",
    "180": "Rechazada: tarjeta no admitida",
    "184": "Rechazada: error de autenticación del titular de la tarjeta",
    "190": "Operación denegada del emisor",
    "191": "Error de fecha de expiración",
    "195": "PSD2: Chip de inserción obligatorio",
    "196": "PSD2: Repetir con PIN",
    "201": "No procesado",
    "202": "Tarjeta bajo sospecha de riesgo de fraude",
    "400": "Operación anulada",
    "600": "Totales",
    "602": "Detalles no disponibles",
    "603": "Recibo no encontrado",
    "700": "Punto de entrada no disponible",
    "749": "Punto de entrada no disponible",
    "900": "Autorizado para reembolso y confirmaciones",
    "904": "MerchantID no encontrado",
    "909": "Error del sistema",
    "912": "Emisor no disponible",
    "913": "OrderID duplicado",
    "916": "MAC inválida",
    "944": "Sesión inválida",
    "948": "Fecha y hora de la terminal local no válidas",
    "950": "Operación de reembolso no permitida",
    "9064": "Datos de tarjeta no válidos",
    "9078": "Operación no permitida para esta tarjeta",
    "9093": "Tarjeta inexistente",
    "9094": "Rechazo de servidores extranjeros",
    "9104": "Comerciante sin información de clave segura",
    "9218": "Operaciones seguras no permitidas para este MerchantID",
    "9253": "Error de dígito de control de Luhn",
    "9256": "Preautorizaciones no permitidas para este MerchantID",
    "9257": "Preautorizaciones no permitidas para esta tarjeta",
    "9261": "Operación Denegada Control de Restricciones Superado",
    "9915": "Operación cancelada por el usuario",
    "9997": "Hay una transacción en curso en SIS con la misma tarjeta",
    "9998": "Solicitud de datos de tarjeta de transacción en curso",
    "9999": "Transacción redirigida al Emisor para Autenticación",
    "9912": "Emisor ​​no disponible",
    "10000": "Tiempo de espera superado",
    "10001": "Error en la conexión",
    "20000": "Datafono usado por otro aplicativo. Debe reintentar la operación.",
  }

  function* isAvaliableApiRequest({ payload }) {
    const { datos_dispositivo: transport } = payload;
    try {
      var { ruta_acceso: url} = transport;
      var port = transport.port ?? DATAFONO_PORT;
      var path = transport.path ?? '/';
      yield put({
        type: COMERCIA_WIFI_IS_AVALIABLE_API_REQUEST,
        payload,
      });
      url = `https://${url}:${port}${path}v1/transactions/init`;
      const jsonData = JSON.stringify({
        user: null,
        pass: null
      });
      const requestParams = {
        url,
        method: 'POST',
        body: jsonData,
        headers: {
          'X-SOURCE': 'COMERCIA'
        }
      };
      //var response = yield call(externalRequest, requestParams);
      var response = yield call(apiInitConection, requestParams);
      yield put({
        type: COMERCIA_WIFI_IS_AVALIABLE_API_SUCCESS,
        payload: response,
      });
    } catch (ex) {
      if (response == null) var response = {};
      response.resultMessage = 'Error al inicializar conexión';
      yield put({ type: COMERCIA_WIFI_IS_AVALIABLE_API_FAILURE, payload: response });
      throw new Error(response.resultMessage);
    }
  }
  function* paymentApiRequest({ payload }) {
    const { amount, datos_dispositivo: transport,  description = 'Venta' } = payload;
    let response = null;
    try {
      var { ruta_acceso: url} = transport;
      var port = transport.port ?? DATAFONO_PORT;
      var path = transport.path ?? '/';
      yield put({
        type: COMERCIA_WIFI_AUTHORIZE_API_REQUEST,
        payload,
      });
      
      var urlPayment = `https://${url}:${port}${path}v1/transactions/payment`;
      const orderId = new Date().getTime();
      const jsonData = JSON.stringify({
        identificationData: {
          orderId,
          referenceNumber: orderId,
        },
        amount,
        orderId,
        description
      });
      const Timeout = (timeout) => {
        let controller = new AbortController();
        setTimeout(() => controller.abort(), timeout);
        return controller;
      };
      const requestParams = {
        url: urlPayment,
        method: 'POST',
        body: jsonData,
        headers: {
          'X-SOURCE': 'COMERCIA',
          'Accept-Charset': 'UTF-8'
        },
        timeout: 5000
      };

      try {
        response = yield call(apiTpvRequest, requestParams);
      } catch (error) {}

      var urlLast = `https:///${url}:${port}${path}v1/transactions/last`;
      response = yield checkAllTimeTransaction(urlLast, orderId);

      yield put({
        type: COMERCIA_WIFI_AUTHORIZE_API_SUCCESS,
        payload: { orderId, response },
      });
      return response;
    } catch (ex) {
      let resultCode = ex.resultCode.toString() ;
      let responseError = typeof(RESPONSE_ERROR[resultCode]) !== "undefined"? RESPONSE_ERROR[resultCode] : 'Error al realizar la acción';
      yield put({ type: COMERCIA_WIFI_AUTHORIZE_API_FAILURE, payload: {response: responseError, orderId: ex.orderId} });
      throw new Error(ex.resultMessage);
    }
  }
 
  // TODO: Añadir más propiedades para montar la url correctamente.
  const checkAllTimeTransaction = (url, orderIdToVerify) => {

    const timeout = 2 * 60 * 1000;
    const controller = new AbortController();
    const signal = controller.signal;
    
    setTimeout(() => {
      controller.abort();
    }, timeout);

    return verifyTransaction(url, orderIdToVerify, signal, 3);
  }


  const verifyTransaction = (url, transactionToVerify, signal, retry) => {
      return new Promise((resolve, reject) => {
        fetch(url, {signal})
        .then((transaction) => {
          return transaction.json();
        })
        .then((transaction) => {
          if(transaction.resultCode === TRANSACTION_RESPONSE_STATUS_OK && (transaction.orderId === transactionToVerify.toString())) {
            return resolve(transaction);
          } else if (transaction.resultCode === 1001) {
            setTimeout( () => {// Este timeout para que entre llamada y llamada de verificación haya un delay de 2 segundos
              verifyTransaction(url, transactionToVerify, signal, 3).then(resolve).catch(reject);
            }, 1000)
          } else {
            if (!transaction.orderId) { // Si no viene el orderID no podemos saber si es un fallo del mismo aplicativo.
              return reject(transaction);
            } else {
              if (transaction.orderId === transactionToVerify.toString()) {
                return reject(transaction);
              } else { //Fallo de otro aplicativo.
                return reject({orderId: transactionToVerify, resultCode: 20000, resultMessage: RESPONSE_ERROR["20000"]});
              }
            }
            
          }
        })
        .catch(error => {
          if ((error.name === 'AbortError') || (retry === 0) ) {
            reject({orderId: transactionToVerify, resultCode: 10000, resultMessage: RESPONSE_ERROR["10000"]});
          }
          else verifyTransaction(url, transactionToVerify, signal, retry - 1).then(resolve).catch(reject);
        })
    });
  }
    function* refundApiRequest({ payload }) {
    const {
      amount, datos_dispositivo: transport, transactionId, description = 'Devolución'
    } = payload;
    let response = null;
    try {
        var { ruta_acceso: url} = transport;
        var port = transport.port ?? DATAFONO_PORT;
        var path = transport.path ?? '/';
      yield put({
        type: COMERCIA_WIFI_REBATE_API_REQUEST,
        payload,
      });

      let urlRefund = `https:///${url}:${port}${path}v1/transactions/refund`;
      const orderId = new Date().getTime();
      const jsonData = JSON.stringify({
        transactionId,
        amount,
        orderId,
        description
      });
      const requestParams = {
        url: urlRefund,
        method: 'POST',
        body: jsonData,
        headers: {
          'X-SOURCE': 'COMERCIA',
          'Accept-Charset': 'UTF-8'
        },
        timeout: 5000
      };

      try {
        response = yield call(apiTpvRequest, requestParams);
      } catch (error) {}

      var urlLast = `https:///${url}:${port}${path}v1/transactions/last`;
      response = yield checkAllTimeTransaction(urlLast, orderId);

      yield put({
        type: COMERCIA_WIFI_REBATE_API_SUCCESS,
        payload: { orderId, response },
      });
      return response;

    } catch (ex) {
      let resultCode = ex.resultCode.toString() ;
      let responseError = typeof(RESPONSE_ERROR[resultCode]) !== "undefined"? RESPONSE_ERROR[resultCode] : 'Error al realizar la acción';
      yield put({ type: COMERCIA_WIFI_REBATE_API_FAILURE, payload: {response: responseError, orderId: ex.orderId} });
      throw new Error(ex.resultMessage);
    }
  }

  function* lastTransactionApiRequest({ payload }) {

    const {
      amount, datos_dispositivo: transport, transactionId, description = 'Last Transaction'
    } = payload;
    let response = null;
    try {
        var { ruta_acceso: url} = transport;
        var port = transport.port ?? DATAFONO_PORT;
        var path = transport.path ?? '/';
      yield put({
        type: COMERCIA_WIFI_LAST_TRANSACTION_API_REQUEST,
        payload,
      });

      url = `https:///${url}:${port}${path}v1/transactions/last`;

      const requestParams = {
        url,
        method: 'GET',
        headers: {
          'X-SOURCE': 'COMERCIA',
          'Accept-Charset': 'UTF-8'
        }
      };
      response = yield call(apiTpvOneRequest, requestParams);

      yield put({
        type: COMERCIA_WIFI_LAST_TRANSACTION_API_SUCCESS,
        payload: { response },
      });
      return response;
    } catch (ex) {
      var message = JSON.parse(ex.message);
      yield put({ type: COMERCIA_WIFI_LAST_TRANSACTION_API_FAILURE, payload: {response: message.response, orderId: message.orderId}  });
      throw new Error(ex.message);
    }
  }

  function* newTransactionRequest({ payload }) {
    try {
      const { mode = 'payment' } = payload;
      let response = null;
      response = yield call(isAvaliableApiRequest, { payload });

      response = null;
      switch (mode) {
        case 'refund':
          response = yield call(refundApiRequest, { payload });
          break;
      
        case 'payment':
          response = yield call(paymentApiRequest, { payload });
          break;

        case 'last_transaction':
          response = yield call(lastTransactionApiRequest, { payload });
          break;
      }

      yield put({
        type: COMERCIA_WIFI_NEW_TRANSACTION_SUCCESS,
        payload: response,
      });
    } catch (e) {
      yield put({ type: COMERCIA_WIFI_NEW_TRANSACTION_FAILURE, payload: e.message });
    }
  }

  function* apiInitConection(data) {
    for (let i = 0; i < 5; i += 1) {
      try {
        return yield call(apiTpvInitRequest, data);
      } catch (err) {
        if (i < 4) {
          yield delay(2000);
        }
      }
    }
  
    throw new Error('Error al inicializar conexión');
  }

  function apiTpvInitRequest({
    method, url, body, headers
  }) {
    const apiURL = url;
    const fetchOptions = {
      method,
      body,
      headers,
    };
  
    return new Promise((resolve, reject) => fetch(apiURL, fetchOptions)
      .then(response => (response.status !== 200 ? reject(response) : response))
      .then(response => resolve(response))
      .catch((error) => { reject(error); console.error(error); }));
  }

  function* apiTpvRequest(data) {
    let response = null;
    let i = 0;
      
    try {
      response = yield call(externalTimeoutRequest, data);
      console.log(response);

    } catch (error) { 
        console.log(error);
        response = { resultCode: (error.message === "AbortError: The user aborted a request.")? 10000 :  10001 }
      
    }
  

    if (!response || response && response.resultCode !== TRANSACTION_RESPONSE_STATUS_OK) {
      let resultCode = response.resultCode.toString() ;
      let responseError = typeof(RESPONSE_ERROR[resultCode]) !== "undefined"? RESPONSE_ERROR[resultCode] : 'Error al realizar la acción';
      throw new Error(JSON.stringify({response: responseError, orderId: (response? response.orderId : null)}));
    } else {
      return response;
    }

  }

  function* apiTpvOneRequest(data) {
    let response = null;
    let i = 0;
      
      try {
        response = yield call(externalTimeoutRequest, data);
        yield delay(2000);
      } catch (error) { 
          response = { resultCode: (error.message === "AbortError: The user aborted a request.")? 10000 :  10001 }
        
      }

    if (!response || response && response.resultCode !== TRANSACTION_RESPONSE_STATUS_OK) {
      let resultCode = response.resultCode.toString() ;
      let responseError = typeof(RESPONSE_ERROR[resultCode]) !== "undefined"? RESPONSE_ERROR[resultCode] : 'Error al realizar la acción';
      throw new Error(JSON.stringify({response: responseError, orderId: (response? response.orderId : null)}));
    } else {
      return response;
    }

  }

  function* comerciaDatafonoWifiSaga() {
    yield all([
      takeLatest(COMERCIA_WIFI_NEW_TRANSACTION_REQUEST, newTransactionRequest),
      takeLatest(LAUNCH_COMERCIA_WIFI_IS_AVALIABLE, isAvaliableApiRequest),
      takeLatest(LAUNCH_COMERCIA_WIFI_AUTHORIZE, paymentApiRequest),
      takeLatest(LAUNCH_COMERCIA_WIFI_REBATE, refundApiRequest),
      takeLatest(LAUNCH_COMERCIA_WIFI_LAST_TRANSACTION, lastTransactionApiRequest),
    ]);
  }

  export default comerciaDatafonoWifiSaga;
